import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const SmallCardListSkeleton: ISkeleton[] = [
  /*{
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 100%',
    classes: 'ml-sm',
    rows: 0,
  },*/
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-sm tw-flex tw-justify-between',
    items: [
      {
        type: SkeletonTypeEnum.TEXT,
        style: 'width: 350px;',
        rows: 0,
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 200px; height: 40px;',
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg mr-xlg ml-sm',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg mr-xlg',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
    ],
  },
  {
    multiple: true,
    style: 'width: 100%',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg mr-xlg ml-sm',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg mr-xlg',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
    ],
  },
  {
    multiple: true,
    style: 'width: 100%',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg mr-xlg ml-sm',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg mr-xlg',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-xlg',
        style: 'width: calc(33% - 30px); height: 100px;',
      },
    ],
  },
];
